import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'semantic-ui-react';

import Button from 'components/elements/buttons/Button';

import './DownloadButton.css';

const DownloadButton = ({ children, onClick }) => (
  <Button
    className="download-button__component"
    onClick={onClick}
  >
    <Icon name="download" />
    {children}
  </Button>
);

DownloadButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.string,
  ]).isRequired,
};

export default DownloadButton;
